import { PndBroadcastMessage } from './broadcast-message.model';

export class FocusUnassignedStopBroadcastingData implements PndBroadcastMessage {
  constructor(public shipmentId: number) {}

  messageId(): string {
    return 'FocusUnassignedStopBroadcastingData';
  }
}
